<!-- 出入库错误数据展示对话框 -->
<template>
  <Dialog
    v-model="dialogOpen"
    :title="title"
    width="1000px"
    :showConfirm="false"
    closedText="关 闭"
  >
    <template #content>
      <div>
        <el-button class="mb5" type="danger" @click="handleExportData"
          >下载数据</el-button
        >
      </div>
      <Table
        ref="tableRef"
        :showSearchComponents="false"
        :showFun="false"
        :columns="tableColumns"
        :data="tableData"
        height="600px"
      ></Table>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Element/Dialog";
import Table from "@/components/Element/Table";
import { isNull } from "@/utils/fangerUtils";
import { getCustomTableCols } from "@/tableColumn";
import { ref, onMounted, watch } from "vue";

const props = defineProps({
  data: {
    required: true,
    type: Array,
  },
  title: {
    required: false,
    type: String,
  },
});

const tableRef = ref(null);
const dialogOpen = ref(false);
const tableData = ref(null);

const tableColumns = getCustomTableCols([
  "eqptCode",
  "productNameByProductId",
  "warehouseNameByWarehouseId",
  {
    label: "备注",
    prop: "remarks",
    textColor: "red",
    minWidth: 160,
  },
]);

const handleExportData = () => {
  tableRef.value.exportData(2);
};

onMounted(() => {
  watch(
    () => props.data,
    (newVal) => {
      if (!isNull(newVal)) {
        dialogOpen.value = true;
        tableData.value = newVal;
      } else {
        tableData.value = [];
      }
    }
  );
});
</script>

<style lang="scss" scoped></style>
